import { registerNotificationKind } from '../registry.js';
/**
 * Module 120's notification kinds (S160-4, REQ-AUT-010), sent through module
 * 50's `NotificationsService`. `monthly_report`: one message per admin and
 * month; `data.month` (`YYYY-MM`), `data.content_titles` (the best posts'
 * titles, at most three) and `data.inbox_message_id` (the report in the inbox).
 */
export const MONTHLY_REPORT = 'monthly_report';
registerNotificationKind({
    kind: MONTHLY_REPORT,
    i18nKey: 'notifications.kind.monthly_report',
    mailTemplate: 'monthly_report',
    linkTarget: (data) => (typeof data.inbox_message_id === 'string' ? `/inbox?message=${data.inbox_message_id}` : '/inbox'),
});
//# sourceMappingURL=120.js.map